module.exports = __webpack_public_path__ + "img/9.5e19b169.jpg";